(function () {
  // Initialise every upsell carousel that does not have a Swiper instance yet.
  // Safe to call repeatedly (e.g. after the cart drawer has been re-rendered).
  const initSlider = () => {
    if (typeof Swiper === "undefined") return;
    document.querySelectorAll(".upsell-products").forEach((el) => {
      if (el.swiper) return;
      new Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 15,
        navigation: {
          nextEl: el.querySelector(".swiper-button-next"),
          prevEl: el.querySelector(".swiper-button-prev"),
        },
      });
    });
  };

  window.initUpsellSliders = initSlider;

  initSlider();
  document.addEventListener("shopify:section:load", initSlider);
})();

if (!customElements.get("cart-upsell")) {
  customElements.define(
    "cart-upsell",
    class CartForm extends HTMLElement {
      constructor() {
        super();

        this.button = this.querySelector(".upsell-add-to-cart");
        this.button.addEventListener("click", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          formData.append("id", this.button.dataset.variantId);
          formData.append("quantity", "1");
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "cart-items",
                productVariantId: this.button.dataset.variantId,
                errors: response.description,
                message: response.message,
              });
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "cart-items",
                productVariantId: this.button.dataset.variantId,
              });
            this.error = false;
            this.cart.renderContents(response);
          })
          .catch((e) => {
            console.error(e);
          });
      }
    }
  );
}

document.addEventListener("DOMContentLoaded", function () {
  function getScope(button) {
    if (!button) return document;
    if (button.dataset.termsScope === "drawer") {
      return button.closest("cart-drawer") || document;
    }
    return document.getElementById("main-cart-footer") || document;
  }

  function getCheckboxFromScope(scope) {
    return scope && scope.querySelector("[data-terms-checkbox]");
  }

  function syncCheckoutButtons() {
    document.querySelectorAll("[data-terms-checkout]").forEach(function (button) {
      const scope = getScope(button);
      const checkbox = getCheckboxFromScope(scope);
      const cartEmpty = button.dataset.cartEmpty === "true";
      const allowed = !cartEmpty && !!checkbox && checkbox.checked;

      button.disabled = !allowed;
      button.setAttribute("aria-disabled", allowed ? "false" : "true");
      button.classList.toggle("is-disabled", !allowed);
    });

    // Also prevent accelerated/dynamic checkout buttons in the cart until terms are accepted.
    document.querySelectorAll("#main-cart-footer .additional-checkout-buttons, cart-drawer .additional-checkout-buttons").forEach(function (container) {
      const scope = container.closest("cart-drawer") || document.getElementById("main-cart-footer") || document;
      const checkbox = getCheckboxFromScope(scope);
      const blocked = !checkbox || !checkbox.checked;
      container.classList.toggle("terms-checkout-blocked", blocked);
      container.setAttribute("aria-disabled", blocked ? "true" : "false");
    });
  }

  document.addEventListener("change", function (event) {
    if (event.target && event.target.matches("[data-terms-checkbox]")) {
      syncCheckoutButtons();
    }
  }, true);

  // Let Shopify handle checkout normally when accepted. Only block the checkout submit when unchecked.
  document.addEventListener("submit", function (event) {
    const form = event.target;
    if (!form || !(form.matches("#cart, #CartDrawer-Form") || form.querySelector("[data-terms-checkout]"))) return;

    const submitter = event.submitter;
    const isCheckoutSubmit = !!submitter && (
      submitter.matches("[data-terms-checkout]") || submitter.name === "checkout"
    );
    if (!isCheckoutSubmit) return;

    const scope = submitter && submitter.dataset.termsScope === "drawer"
      ? (submitter.closest("cart-drawer") || document)
      : (document.getElementById("main-cart-footer") || document);
    const checkbox = getCheckboxFromScope(scope);

    if (!checkbox || !checkbox.checked) {
      event.preventDefault();
      event.stopImmediatePropagation();
      syncCheckoutButtons();
      const label = scope.querySelector(".terms-checkbox");
      if (label) {
        label.classList.add("terms-checkbox--error");
        label.scrollIntoView({ block: "nearest", behavior: "smooth" });
      }
    }
  }, true);

  // Block accelerated checkout buttons in the cart when terms have not been accepted.
  document.addEventListener("click", function (event) {
    const accelerated = event.target && event.target.closest && event.target.closest(
      "#main-cart-footer .additional-checkout-buttons *, cart-drawer .additional-checkout-buttons *"
    );
    if (!accelerated) return;

    const container = accelerated.closest(".additional-checkout-buttons");
    if (!container || !container.classList.contains("terms-checkout-blocked")) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    const scope = container.closest("cart-drawer") || document.getElementById("main-cart-footer") || document;
    const label = scope.querySelector(".terms-checkbox");
    if (label) {
      label.classList.add("terms-checkbox--error");
      label.scrollIntoView({ block: "nearest", behavior: "smooth" });
    }
  }, true);

  const observer = new MutationObserver(function () {
    syncCheckoutButtons();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  syncCheckoutButtons();
});
